import React from 'react';

export const BlogSegmentExperience = (props) => {
    return (
        <div className='blog-con'>
            <section>
                <p>Unlike traditional segmentation, which relies on static, predefined categories, dynamic segmentation adapts in real time based on a customer's behavior, preferences, and interactions.</p>
                <p>This transformation enables brands to deliver personalized content, offers, and experiences that are more relevant, timely, and engaging. By harnessing the power of dynamic segmentation, businesses can optimize every customer interaction, driving higher conversion rates, improving customer satisfaction, and fostering long-term loyalty.</p>
                <p>In this blog, we'll explore how dynamic segmentation is reshaping personalized experiences and why it's essential for staying competitive.</p>
            </section>
            <section>
                <h2>How to Create a Segment</h2>
                <ul>
                    <li>Go to the Site Menu</li>
                    <li>Navigate to People → Segments</li>
                    <li>Click "Add"</li>
                </ul>
                <p><img src="/images/blogs/segment1.png" alt="liferay-segments" style={{width: '100%'}} /></p>
                <p>Now you're ready to use the segments.</p>
                <p>Let's take a look at an example:</p>
                <ul>
                    <li>Go to the property sidebar</li>
                    <li>In the session, select "URL" and drag it into Conditions</li>
                    <li>Set the condition to: URL contains ?scientist</li>
                </ul>
                <p><img src="/images/blogs/segment2.png" alt="liferay-segments-example" style={{width: '100%'}} /></p>
                <p>Now we've created a segment for scientists. Let's move on to personalizing the content on our website using this segment.</p>
            </section>
            <section>
                <h2>Adding the Segment to Content</h2>
                <p>Let's apply this to a collection on our site:</p>
                <ul>
                    <li>Go to the Site Menu</li>
                    <li>Navigate to Site Builder → Collections</li>
                    <li>Create a new Dynamic Collection</li>
                    <li>Give it a title: <strong>Our New Research</strong> and create a collection for the item type "Web Content Article"</li>
                    <li>Select your preferred structure and save.</li>
                    <li>Edit the collection</li>
                    <li>On the left sidebar, select "ADD PERSONALIZED VARIATION"</li>
                    <li>Select our "Scientist" segment</li>
                    <li>Select item type "Web Content Article"</li>
                    <li>Select your preferred structure</li>
                    <li>In the filter, set conditions like: Contains → Any → Tags → Select all tags related to scientists that you created when adding web articles</li>
                    <li>Make sure to drag and drop the "Scientist" segment to the top of the Personalized Variations</li>

                    <img src="/images/blogs/segment3.png" alt="liferay-segments" style={{width: '100%'}} />
                    <li>Save the collection</li>
                </ul>
                <p>Now we are all set to use dynamic personalization in this collection.</p>
            </section>
            <section>
                <h2>Check How It Works</h2>
                <ul>
                    <li>Create a content page</li>
                    <li>Place the collection <strong>Our New Research</strong> on the page</li> 
                    <li>Publish the page</li>
                </ul>
                <p>You'll see all the web content articles on that page as usual. Now, pass the parameter ?scientist in the URL. You'll witness the magic!</p>
                <p>This is just one example of using segment personalization. You can create segments for engineers, doctors, lawyers, businessmen, and many more for our case. Without much effort and configuration, you can now display different views and personalized content for the same collection.</p>
                <p>Here, we've used segments for collections, but you can also apply personalization within the context of layouts. Personalizing content on each page provides a better user experience with minimal effort.</p>
            </section>

            <section>
                <h2>Personalization in Pages</h2>
                <ul>
                    <li>Create a new content page</li>
                    <li>Add some fragments and create a common page for all users</li>
                    <li>Now go to left side Select experience and click on <strong>New Experience</strong></li>
                    <li>Give name and <strong>select</strong> respective segment and <strong>save</strong>.</li>
                </ul>
                <img src="/images/blogs/segment4.png" alt="liferay-segments" style={{width: '100%'}} />
                <p>Now you can modify content and fragments according to scientist POV and publish the page.</p>
                <p>You can check same way as we checked in content personalization.</p>
            </section>

            <section>
                <p>This is just a one way to create segments and use it based on url in our example. There is lots of more options available for creating segments like using <strong>based on devices you use, age specific personalization, paricular region wise personalization, based on categories and tags, for specific organizations and many more.</strong></p>
            </section>

            <section>
                <h2>Conclusion</h2>
                <p>Dynamic segmentation is a game changer when it comes to creating personalized experiences that truly resonate with users. By using real-time data to tailor content and interactions, businesses can boost engagement, drive conversions, and foster long-term loyalty.</p>
                <p>The steps outlined in this blog show just how easy it is to implement dynamic segmentation for personalized content, but the possibilities are endless. Whether you're targeting different professions or customer behaviors, dynamic segmentation allows you to adapt and evolve your strategy with minimal effort, providing a unique, highly relevant experience for every user. Embrace dynamic segmentation and watch how it transforms the way you engage with your customers.</p>
                <p>Happy coding! &#128521;</p>
            </section>
        </div>
    );
};
